<div class="splitAreaContent" #splitAreaContent>
  <div class="tab-split-view-content-blade-content" #contentParent><ng-template #content></ng-template></div>
</div>
